import { useState, useEffect, useContext } from 'react';

import { cmnContext } from '../../../../common/CmnContext';
import { PracticeReseveContext } from '../../PracticeReseveContext';
import Modal from '../../../../common/Modal';
import PracticeReserveDatetimeModal from './modal/PracticeReserveDatetimeModal';

import {
  formatDate, formatTime, formatTimeAddMin
} from '../../../../../util/utility';


// 日程選択
function PracticeReserveDatetime() {

  const { isPc } = useContext(cmnContext);
  const {
    lsnMin, isLesson, calendar, selectedScheduleId,
  } = useContext(PracticeReseveContext);

  const [dispDate, setDispDate] = useState<string>('');
  const [dispDateTime, setDispDateTime] = useState<string>('');
  // モーダル表示
  const [isDispModal, setIsDispModal] = useState<boolean>(false);


  // 選択時にモーダルを閉じる
  useEffect(() => {
    setIsDispModal(false);
  }, [selectedScheduleId])


  // 予約日時
  useEffect(() => {
    // 選択が外れたとき（モード切り替えなど API を呼び直さない場合）は表示を消す
    setDispDate('');
    setDispDateTime('');
    for(const date in calendar) {
      const times = calendar[date];
      for(const time in times) {
        if(times[time] == selectedScheduleId) {
          setDispDate(formatDate(date));
          // 時間を"HH:MM"に整形
          setDispDateTime(`${formatTime(time)}〜${formatTimeAddMin(time, lsnMin)}`);
        }
      }
    }
  }, [calendar, selectedScheduleId])


  return (
    <>
    {isLesson &&
      <>
        <div style={{
          display: 'flex',
          alignItems: 'end',
          justifyContent: 'space-between',
          marginTop: '20px',
          marginBottom: '30px',
        }}>

          <div>
            <label className="control-label" htmlFor="contact-birth" style={{
              backgroundColor: '#eaf3ff',
              padding: '0.25em 3em 0.25em 0.5em',
              borderLeft: 'solid 5px #516ab6',
            }}>
              レッスンの日程
            </label>
            <div style={{marginLeft: '5px'}}>
              <p style={{
                margin: 0,
                fontSize: '16px',
                // バリデーションStyle
                ...(!selectedScheduleId ? 
                  {
                    backgroundColor: 'red',
                    color: '#fff',
                    padding: '3px 10px',
                  }
                  : {}
                )
              }}>
                {(dispDate && dispDateTime) ?
                  <>{dispDate}&nbsp;&nbsp;{dispDateTime}</>
                :
                  <>日程を選んでください</>
                }
              </p>
            </div>
          </div>

          <div style={{marginRight: isPc? '5px':0}}>
            <button
              type="button"
              className='btn btn-primary'
              style={{
                width: '100%',
                margin: isPc? '10px 0 0' : '5px 0 0',
              }}
              onClick={() => setIsDispModal(true)}
            >
              {(selectedScheduleId)? '選び直す' : '日程を選ぶ' }
            </button>
          </div>

        </div>

        {/* 選択モーダル */}
        <Modal
          comp={<PracticeReserveDatetimeModal />}
          isDispModal={isDispModal}
          setIsDispModal={setIsDispModal}
          isDispClose={true}
        />
      </>
    }
    </>
  );
}
  
export default PracticeReserveDatetime;